import axios from "axios";
import { SetStateAction } from "react";
import { setButtonActionClicked, setConfirmationMessage, setConfirmationTittle } from "@/components/DataTable/Datatable.variables";
import { IVendorContactInformationFormData } from "@/context/data.types";
import { getPayloadMelissaCountryName, getResponseMelissaCountryName } from "@/utils/countryMapping";
// import VendorContactInformationForm from "@/components/VendorContactInformationForm";

export const handleSuggestionsFetchRequested = async (payloadRef:any, setAddressSuggestions:SetStateAction<any>, selectedCountryId?: string | number) => {
  const { current: payload } = payloadRef;
  if (payload?.country) {
    payload.country = getPayloadMelissaCountryName(String(payload.country));
  }
  // Only these keys are sent to Melissa suggestions (city/state/zip are not used to narrow results)
  const suggestionPayloadKeys = ["maxrecords", "country", "address1"];
  const queryParams = new URLSearchParams({
      id: process.env.NEXT_PUBLIC_MELISSA_EXPRESS_ENTRY_API_KEY || '',
      format: "json",
      ...Object.fromEntries(
        Object.entries(payload ?? {}).filter(([key, v]) => v && suggestionPayloadKeys.includes(key))
      ),
    }).toString();

    try {
      const response = await axios.get(`${process.env.NEXT_PUBLIC_MELISSA_EXPRESS_ENTRY_API_URL}?${queryParams}`);
      
      if (response.data?.Results) {
        const melissaCountryName = selectedCountryId 
          ? getResponseMelissaCountryName(String(selectedCountryId))
          : null;
        
        // Filter by country and update AdministrativeArea in a single loop
        const filteredResults = response.data?.Results.reduce((acc: any[], result: any) => {
          // Filter by country if selectedCountryId is provided
          if (melissaCountryName) {
            const addressCountryName = result?.Address?.CountryName;
            const matchesCountry = String(addressCountryName).toLowerCase() === String(melissaCountryName.toLowerCase());
            if (!matchesCountry) {
              return acc; // Skip this result if it doesn't match country filter
            }
          }
          
          // Update AdministrativeArea from CountrySubdivisionCode
          if (result?.Address?.CountrySubdivisionCode) {
            result.Address.AdministrativeArea = result.Address.CountrySubdivisionCode.split('-')[1] || result?.Address?.AdministrativeArea;
          }
          
          acc.push(result);
          return acc;
        }, []);
        
        setAddressSuggestions(filteredResults);
      } else {
        setAddressSuggestions([]);
      }
    } catch (err) {
      console.error("API Error:", err);
    }
  };

export const validateAddress = async (address: {
      street: string;
      city: string;
      state: string;
      country: string;
      postalCode: string;
    }, messagesText:any, 
    setIsLoading: SetStateAction<any>
) => {
      const { street, city, state, country, postalCode } = address;
      const url = `${process.env.NEXT_PUBLIC_MELISSA_GLOBAL_ADDRESS_VALIDATION_API_URL}?t=&id=${process.env.NEXT_PUBLIC_MELISSA_GLOBAL_ADDRESS_VALIDATION_API_KEY}&a1=${encodeURIComponent(
          street
      )}&loc=${encodeURIComponent(city)}&subadmarea=${encodeURIComponent(
        state
      )}&postal=${encodeURIComponent(postalCode)}&ctry=${encodeURIComponent(
        country
      )}&format=JSON`;
      let resultCode: string[] = [];
      try {
        const response = await axios.get(url);
        const data = response.data;
        setIsLoading(false);
        if (data && data.Records) {
           resultCode = data.Records[0]?.Results?.split(',') || [];

           if (resultCode) {
                if (  
                resultCode.some((code : string) => code.startsWith("AE")) ||
                resultCode.some((code : string) => code.startsWith("AC")) || "GE14" //transmission error code
                ) {
                    setConfirmationMessage(messagesText?.CONFIRMATION_BOX_MESSAGES?.CONFIRM_MESSAGE?.CP_SLM_VI_ADDRESS_NOT_FOUND_CONFIRM_MSG);
                    setConfirmationTittle(messagesText?.CONFIRMATION_BOX_MESSAGES?.CONFIRM_TITLE?.CP_SLM_VI_ADDRESS_NOT_FOUND_CONFIRM_TITLE);
                    setButtonActionClicked(messagesText?.CONFIRMATION_BOX_MESSAGES?.CONFIRM_ACTION?.CP_SLM_VI_ADDRESS_NOT_FOUND_CONFIRM_BUTTON_ACTION);
                    setButtonActionClicked(messagesText?.CONFIRMATION_BOX_MESSAGES?.CONFIRM_ACTION?.CP_SLM_VI_ADDRESS_NOT_FOUND_CANCEL_BUTTON_ACTION);
                    return true;
                    // openModal()      
                    }
                }
            }
        } catch (error: any) {
            console.error("Melissa API Error:", error);
            setConfirmationMessage(messagesText?.CONFIRMATION_BOX_MESSAGES?.CONFIRM_MESSAGE?.CP_SLM_VI_ADDRESS_NOT_FOUND_CONFIRM_MSG);
            setConfirmationTittle(messagesText?.CONFIRMATION_BOX_MESSAGES?.CONFIRM_TITLE?.CP_SLM_VI_ADDRESS_NOT_FOUND_CONFIRM_TITLE);
            setButtonActionClicked(messagesText?.CONFIRMATION_BOX_MESSAGES?.CONFIRM_ACTION?.CP_SLM_VI_ADDRESS_NOT_FOUND_CONFIRM_BUTTON_ACTION);
            setButtonActionClicked(messagesText?.CONFIRMATION_BOX_MESSAGES?.CONFIRM_ACTION?.CP_SLM_VI_ADDRESS_NOT_FOUND_CANCEL_BUTTON_ACTION);
            setIsLoading(false);
        }
        return false;
    
    };

// Handler function for AutoComplete input change
export const updatePayload = (payloadRef:any, field: keyof IVendorContactInformationFormData, value: string) => {

    // Map fields to corresponding payload keys
    const fieldMap: { [key in keyof IVendorContactInformationFormData]: string } = {
      corporateAddress: "address1",
      corporateCity: "locality",
      corporateState: "administrativearea",
      corporateCountry: "country",
      corporateZip: "postalcode",
      vendorName: "",
      contactFor: "",
      contactPersonEmailId: "",
      contactPersonPhone: ""
    };

    const payloadKey = fieldMap[field];

    if (payloadKey) {
      payloadRef.current = { ...payloadRef.current, [payloadKey]: value }; // Merge old and new values
    }
  };

export const setAddressConfirmationMessage = (messageTexts:any) => {
  setConfirmationMessage(messageTexts?.CONFIRMATION_BOX_MESSAGES?.CONFIRM_MESSAGE?.CP_SLM_VI_ADDRESS_NOT_FOUND_CONFIRM_MSG);
  setConfirmationTittle(messageTexts?.CONFIRMATION_BOX_MESSAGES?.CONFIRM_TITLE?.CP_SLM_VI_ADDRESS_NOT_FOUND_CONFIRM_TITLE);
  setButtonActionClicked(messageTexts?.CONFIRMATION_BOX_MESSAGES?.CONFIRM_ACTION?.CP_SLM_VI_ADDRESS_NOT_FOUND_CONFIRM_BUTTON_ACTION);
  setButtonActionClicked(messageTexts?.CONFIRMATION_BOX_MESSAGES?.CONFIRM_ACTION?.CP_SLM_VI_ADDRESS_NOT_FOUND_CANCEL_BUTTON_ACTION);
}